/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExtendedUserDTO } from './ExtendedUserDTO';
import {
    ExtendedUserDTOFromJSON,
    ExtendedUserDTOFromJSONTyped,
    ExtendedUserDTOToJSON,
} from './ExtendedUserDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * ExtendedUserDTO extends User model to provide username
 * @export
 * @interface ExtendedUserPageDTO
 */
export interface ExtendedUserPageDTO {
    /**
     * 
     * @type {Array<ExtendedUserDTO>}
     * @memberof ExtendedUserPageDTO
     */
    content?: Array<ExtendedUserDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedUserPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedUserPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExtendedUserPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtendedUserPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof ExtendedUserPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof ExtendedUserPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof ExtendedUserPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof ExtendedUserPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtendedUserPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the ExtendedUserPageDTO interface.
 */
export function instanceOfExtendedUserPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExtendedUserPageDTOFromJSON(json: any): ExtendedUserPageDTO {
    return ExtendedUserPageDTOFromJSONTyped(json, false);
}

export function ExtendedUserPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendedUserPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(ExtendedUserDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function ExtendedUserPageDTOToJSON(value?: ExtendedUserPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(ExtendedUserDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

